/* eslint-disable no-underscore-dangle */
/* eslint-disable no-param-reassign */
/* eslint-disable no-shadow */
import Vue from 'vue'
import axios from 'axios'

axios.defaults.baseURL = process.env.VUE_APP_baseUrl
axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded'

axios.interceptors.request.use(
  config => {
    const token = localStorage.getItem('token')
    if (!token) return config
    const existingAuth = config?.headers?.Authorization || config?.headers?.authorization
    if (existingAuth) return config
    return {
      ...config,
      headers: {
        ...(config.headers || {}),
        Authorization: `Token ${token}`,
      },
    }
  },
  error => Promise.reject(error),
)

const config = {
  baseURL: process.env.VUE_APP_baseUrl,
}

const _axios = axios.create(config)

_axios.interceptors.request.use(
  config => {
    const token = localStorage.getItem('token')
    if (!token) return config
    const existingAuth = config?.headers?.Authorization || config?.headers?.authorization
    if (existingAuth) return config
    return {
      ...config,
      headers: {
        ...(config.headers || {}),
        Authorization: `Token ${token}`,
      },
    }
  },
  error => Promise.reject(error),
)

_axios.interceptors.response.use(
  response => response,
  error => Promise.reject(error),
)

const Plugin = {
  install(Vue) {
    Vue.axios = _axios
    window.axios = _axios
    Object.defineProperties(Vue.prototype, {
      axios: {
        get() {
          return _axios
        },
      },
      $axios: {
        get() {
          return _axios
        },
      },
    })
  },
}

Vue.use(Plugin)

export default Plugin
